import { get, post, put, deleted } from '../utils/http';

export function getEventForm(param, code) {
    return post(`${code}event/getform`, param);
};

export function customerRegister(url, param) {
    return post(url, param);
};